import axios from "axios";

// Determine if we're in GitHub Codespaces and adjust URL accordingly
const isCodespaces = window.location.hostname.includes("app.github.dev");
const BASE_URL =
  process.env.REACT_APP_API_URL ||
  (isCodespaces
    ? `https://${window.location.hostname.replace("3006", "3000")}/api/v1`
    : "http://localhost:5000/api/v1");

console.log("Password API using base URL:", BASE_URL);

const passwordAPI = {
  /**
   * Find a user by university ID and return a masked email
   * @param {string} universityId - The university ID to search for
   * @returns {Promise} - Promise with the response
   */
  findByUniversityId: async (universityId) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/password/find-by-university-id`,
        {
          universityId,
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Send a password reset email to a user identified by university ID
   * @param {string} universityId - The university ID of the user
   * @returns {Promise} - Promise with the response
   */
  resetByUniversityId: async (universityId) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/password/reset-by-university-id`,
        {
          universityId,
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default passwordAPI;
